import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import type { Me } from "../hooks/useAuth";

export function Login({ onAuthed }: { onAuthed: (me: Me) => void }) {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const nav = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const res = await api.login(email, pw);
      onAuthed({ email: res.email, is_admin: res.is_admin });
      nav("/");
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-paper-50">
      <form onSubmit={submit} action="/api/auth/login" method="post"
            className="w-full max-w-xs space-y-8" autoComplete="on">
        <div className="text-center space-y-2">
          <div className="eyebrow">Coffee Vault</div>
          <h1 className="font-display text-3xl">Sign in</h1>
        </div>
        <div className="space-y-5">
          <div>
            <label htmlFor="email" className="label">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="password" className="label">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              className="input"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              required
            />
          </div>
        </div>
        {error ? <div className="text-red-700 text-xs">{error}</div> : null}
        <button type="submit" className="btn-primary w-full" disabled={busy}>
          {busy ? "Signing in…" : "Continue"}
        </button>
      </form>
    </div>
  );
}
